import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/mcomponent/provider_customer/');

const state = {
    ...current_module.state,
    columns: [
        {text: '', value: 'deleted', sortable: false, filterable: true, divider: true, width: 30},
        {text: '', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
        {text: 'N', value: 'notion_id', sortable: false, filterable: true, divider: true,},
        {text: 'Name', value: 'name', sortable: true, filterable: true, divider: true,},
        {text: 'Alias', value: 'alias', sortable: false, filterable: true, divider: true,},
        // {text: 'Address', value: 'address', sortable: false, filterable: true, divider: true,},
        {text: 'Phones', value: 'phones', sortable: false, filterable: true, divider: true,},
        // {text: 'URL', value: 'url', sortable: false, filterable: true, divider: true,},
        // {text: 'Note', value: 'note', sortable: false, filterable: true, divider: true,},
        {text: 'Cache time', value: 'cache_time', sortable: false, filterable: true, divider: true,},
        {text: 'Priority', value: 'priority', sortable: false, filterable: true, divider: true,},
        {text: 'Scrab enable', value: 'scrap_enable', sortable: true, filterable: true, divider: true, type: 'bool'},
        // {text: 'Color', value: 'background_color', sortable: false, filterable: true, divider: true,},
        {text: 'Created by', value: 'created_by_name', sortable: true, divider: true, },
        {text: 'Created on', value: 'created_on', sortable: true, divider: true, type: 'datetime',},
        {text: 'Edited by', value: 'edited_by_name', sortable: true, divider: true, },
        {text: 'Edited on', value: 'edited_on', sortable: true, divider: true, type: 'datetime', },
    ],
    options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['name'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filtersArg: {
        from_date: null,
        to_date: null,
    },
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        ProviderCustomerTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}